import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component<MiLogs>({
  //
})
export default class MiLogs extends Vue {
  @Prop({ default: () => [] })
  protected logs!: Log[];
  protected okButton: boolean = false;

  protected mounted() {}
}

export interface Log {
  title: string;
  text: string;
}
